<template>
    <el-dialog
      :visible="hintDialog"
      @close="handleClose"
      :show-close="false"
    >
      <div class="hint-box">
        <div class="hint-head">提示</div>
        <div class="hint-center">建议启用会商机制</div>
        <div class="hint-bt">
          <div class="bt" @click="handleClose">确认</div>
        </div>
      </div>
    </el-dialog>
</template>

<script>
  export default {
    name: "History",
    props:{
      hintDialog:{
        default:false
      }
    },
    data() {
        return {
          input:''
        };
    },
    methods:{
      handleClose() {
        this.$emit('handle-close')
      },
    }

  }
</script>

<style lang="less" scoped>
/deep/.el-dialog{
  background: #262D40;
  height: 232px;
  width: 400px;
  border-radius: 12px;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 20px;
  }
  .el-dialog__headerbtn{
    top: 23px;
  }
  .hint-box{
    .hint-head{
      font-size: 20px;
      line-height: 68px;
    }
    .hint-center{
      font-size: 16px;
      padding: 24px;
    }
    .hint-bt{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .bt{
        width: 352px;
        border-radius: 50px;
        margin: 0 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hint.vue